// extracted by mini-css-extract-plugin
export default {"socialIcon":"SocialIcon__socialIcon___gm1fE"};